import { defineComponent as _defineComponent } from 'vue'
import { Icon } from '@iconify/vue2'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyFireOutbreakList',
  setup(__props) {

const title = computed(() => 'Nenhum registro encontrado')

const subtitle = computed(() => 'Aguarde a notificação dos alertas para visualizar os registros.')

const icon = computed(() => 'fa6-solid:folder-open')

return { __sfc: true,title, subtitle, icon, Icon }
}

})